import { HttpClient, HttpParams } from '@angular/common/http';
import { buildGridParams } from 'src/app/shared/utils/grid-params.util';
import { getRegionApiUrl } from '../_helpers/region.helper';

export class EndpointService {

    constructor(protected http: HttpClient) { }

    protected getApiUrl(url: string) {
        return `${getRegionApiUrl()}/${url}`;
    }

    protected createParams(filter: string, orderBy: string, sort: string, page: number, pageSize: number) {
        return new HttpParams()
            .set('filter', filter)
            .set('orderBy', orderBy)
            .set('sort', sort)
            .set('page', page.toString())
            .set('pageSize', pageSize.toString());
    }

    protected createParamsWithFilterBy(filter: string, orderBy: string, sort: string, page: number, pageSize: number, filterBy: string) {
        return buildGridParams(filter, orderBy, sort, page, pageSize, filterBy);
    }

}
